import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { onMounted } from 'vue'
    import { useSystemStatsQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SystemStatsPage',
  setup(__props) {

    const { modelSystemStatsQueryV1, runSystemStatsQueryV1 } = useSystemStatsQueryV1()

    onMounted(() => runSystemStatsQueryV1())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" TotalAvailableMemoryBytes: " + _toDisplayString(_unref(modelSystemStatsQueryV1).TotalAvailableMemoryBytes), 1 /* TEXT */),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" WorkingSet64: " + _toDisplayString(_unref(modelSystemStatsQueryV1).WorkingSet64), 1 /* TEXT */),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" TotalMemory: " + _toDisplayString(_unref(modelSystemStatsQueryV1).TotalMemory), 1 /* TEXT */),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" TotalAllocatedMemory: " + _toDisplayString(_unref(modelSystemStatsQueryV1).TotalAllocatedMemory), 1 /* TEXT */),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" Gen0Collections: " + _toDisplayString(_unref(modelSystemStatsQueryV1).Gen0Collections), 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" Gen1Collections: " + _toDisplayString(_unref(modelSystemStatsQueryV1).Gen1Collections), 1 /* TEXT */),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createTextVNode(" Gen2Collections: " + _toDisplayString(_unref(modelSystemStatsQueryV1).Gen2Collections), 1 /* TEXT */),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */))
    ])
  ]))
}
}

})